import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ChineseReferFriend } from "@/components/ChineseReferFriend";
import { SEO } from "@/components/SEO";
import { LocationContext } from "@/lib/locations";

const ChineseReferralPage = () => {
  return (
    <LocationContext.Provider value={{ slug: "sacramento-area", name: "加州", type: "region", regionSlug: "sacramento-area" }}>
      <div className="flex min-h-screen flex-col">
        <SEO 
          title="推荐好友 | Uplevel Cleaning"
          description="向朋友推荐 Uplevel Cleaning，双方均可在下次预约时享受 $20 折扣优惠。"
          url="https://uplevelcleaning.com/zh/referral"
          alternateLang="zh"
          includeLocalBusiness={false}
          includeFAQ={false}
        />
        <Navbar />
        <main className="flex-1 pt-24">
          <ChineseReferFriend />
        </main>
        <Footer />
      </div>
    </LocationContext.Provider>
  );
};

export default ChineseReferralPage;
